import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import type { FleetUpdatePayload } from "~/modules/fleet/models/FleetUpdatePayload.interface";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useUpdateFleet({
  organizationCode,
}: GenericServiceParameters<void>) {
  const result = ref();
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function updateFleet(
    uid: string,
    fleet: FleetUpdatePayload,
  ): Promise<void> {
    isLoading.value = true;

    const response = await fleetService.updateOrganizationFleet({
      organizationCode,
      uid,
      fleetUpdatePayload: fleet,
    });

    if (LxcError.check(response)) {
      error.value = response;
      result.value = undefined;
    } else {
      error.value = null;
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateFleet,
    result,
    error,
    isLoading,
  };
}
